// extracted by mini-css-extract-plugin
export default {"links_register":"RegisterLinks_links_register__1u8MU","link":"RegisterLinks_link__Cfbo5"};